// components/LoadingScreen.js //
import React, { useEffect, useState } from "react";

const LoadingScreen = () => {
  const [dots, setDots] = useState('');
  const [message, setMessage] = useState('Charging');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prevDots) => {
        if (prevDots.length >= 3) return '';
        return prevDots + '.';
      });
    }, 300);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-white z-50">
      <div className="relative">
        <span className="text-5xl font-display font-bold text-primary uppercase tracking-logo">
          {message}<span className="text-primary">{dots}</span>
        </span>
        <span className="absolute right-0 top-0 h-full w-0.5 bg-black animate-cursor"></span>
      </div>
    </div>
  );
};

export default LoadingScreen;
